import React, { ReactNode } from 'react';

import { IntlProvider } from 'react-intl';

import i18nMessages, { Translations, Language } from '~/i18n/messages';

export const DEFAULT_LOCALE = 'en';
export const JAPANESE_LOCALE = 'ja';

export const localizeLink = (locale, defaultLocale, value) => {
  return locale === defaultLocale ? value : `/${locale}${value}`;
};

export const I18nProvider = ({
  children,
  locale,
}: {
  children: ReactNode;
  locale: Language;
}) => {
  const messages: Translations = i18nMessages[locale];

  return (
    <IntlProvider
      defaultLocale={DEFAULT_LOCALE}
      locale={locale}
      textComponent={React.Fragment}
      messages={messages}
    >
      {children}
    </IntlProvider>
  );
};
